import React, { Component } from "react";
import _ from "lodash";
import {
  Button,
  Card,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from "reactstrap";
import BootstrapTable2 from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import Loader from "../../../commons/loader";
import paginationFactory from "react-bootstrap-table2-paginator";
import Lib from '../../../commons/lib';
import Services from "../services";
import PromociokForm from "./PromociokForm";
import { PaginationTotal } from "../../../commons/controls";
import DataEmptyState from "../../../commons/dataemptystate";
import { ProgressButton } from '../../../commons/ProgressButton';
import NetworkEmptyState from "../../../commons/networkemptystate";
import RFForm from "../../../components/Form/RFForm";
import RFField from "../../../components/Form/RFField";

class PromociokContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      
      // DATA
      baseJson: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,
      img: null,

      // FORM
      formEloadas: null,
      formHelyszinek: [],
      formObjects: [],
      formObjectsAngol: [],

      // MODAL UTILS
      formTypeStatus: false,
      modalView: false,
      modalDelete: false,
      modalForm: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      kepModal: false,

      // PARAMETER
      angolNyelv: false,
    };
  }

  componentDidMount() {
    this.listPromocio();
    this.checkAngolNyelv();
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleKepModal = () => {
    this.setState(prevState => ({ kepModal: !prevState.kepModal }));
  }

  listPromocio = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listPromocio(null, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  checkAngolNyelv = () => {
    Services.getAngolNyelv((err, res) => {
      if (!err) {
        this.setState({ angolNyelv: res[0] });
      }
    });
  }

  getPromocioView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.viewPromocio(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  getPromocioForm = (id) => {
    this.setState({
      formStatus: 'LOAD',
    }, () => {
      Services.getPromocio(id, (err, res) => {
        if (!err) {
          this.setState({
            formStatus: 'DATA',
            formEloadas: res[0].eloadas,
            formHelyszinek: res[0].helyszinek,
            formObjects: res[0].objects.filter(obj => !obj.angol),
            formObjectsAngol: res[0].objects.filter(obj => obj.angol)
          });
        } else {
          this.setState({
            formStatus: 'NETW'
          });
        }
      });
    });
  }

  savePromocio = () => {
    const {
      currentId,
      formTypeStatus,
      formEloadas,
      formHelyszinek,
      formObjects,
      formObjectsAngol,
    } = this.state;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeStatus == 'FEL') {
        let submitObj = {};
        submitObj.eloadasid = formEloadas.id;
        submitObj.helyszinids = formHelyszinek && formHelyszinek.map(h => h.id);
        submitObj.objects = formObjects.concat(formObjectsAngol);
  
        Services.addPromocio(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Promóció felvéve!');
            this.toggleFormModal();
            this.listPromocio();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else if(formTypeStatus == 'MOD') {
        let submitObj = {};
  
        submitObj.id = currentId;
        submitObj.eloadasid = formEloadas.id;
        submitObj.helyszinids = formHelyszinek && formHelyszinek.map(h => h.id);
        submitObj.objects = formObjects.concat(formObjectsAngol);

        Services.editPromocio(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Promóció módosítva!');
            this.toggleFormModal();
            this.listPromocio();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  deletePromocio = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deletePromocio(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listPromocio();
        this.props.globals.addSuccess('Előadás törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  onDropObjects = (acceptedfiles, language) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        let files;
        if (!this.state.angolNyelv || language == 'hu')
          files = this.state.formObjects || [];
        else
          files = this.state.formObjectsAngol || [];
        files.push({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: false,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          angol: this.state.angolNyelv && language == 'en',
          //id: Lib.Browser.uuidv4(),
        });
        if (!this.state.angolNyelv || language == 'hu')
          this.setState({ formObjects: files });
        else
        this.setState({ formObjectsAngol: files });
      };
      reader.readAsBinaryString(file);
    });
  }

  onDeleteClick = (item, language) => {
    if (!this.state.angolNyelv || language == 'hu') {
      this.setState((prevState) => (
        { formObjects: prevState.formObjects.filter(j => j.docname != item.docname) }
      ));
    } else {
      this.setState((prevState) => (
        { formObjectsAngol: prevState.formObjectsAngol.filter(j => j.docname != item.docname) }
      ));
    }
  }


  handleNewClick = () => {
    this.setState({
      currentId: null,
      formStatus: 'DATA',
      formTypeStatus: 'FEL',
      formEloadas: null,
      formHelyszinek: [],
      formObjects: [],
      formObjectsAngol: [],
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formTypeStatus: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getPromocioForm(id);
      this.toggleFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getPromocioView(id, false);
      this.toggleViewModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleImgClick = (img, idx) => {
    img.index = idx;
    this.setState({ img }, () => { this.toggleKepModal() });
  }

  handleAltChangeClick = () => {
    const { angolNyelv, img } = this.state;
    if (angolNyelv && img.angol) {
      let array = this.state.formObjectsAngol;
      array.splice(img.index, 1, img);
      this.setState({ formObjectsAngol: array });
    } else {
      let array = this.state.formObjects;
      array.splice(img.index, 1, img);
      this.setState({ formObjects: array });
    }
    this.toggleKepModal();
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        <React.Fragment> 
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
            {'Megtekintés'}
          </UncontrolledTooltip>

          <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
            {'Módosítás'}
          </UncontrolledTooltip>

          <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
            {'Törlés'}
          </UncontrolledTooltip>
        </React.Fragment>
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    let objects = [];
    let objectsAngol = [];
    if (viewObj.cim && viewObj.objects) {
      viewObj.objects.forEach((object, index) => {
        let key = index;
        let img = <React.Fragment>
          <br />
          <img src={'data:image/bmp;base64,' + object.content} width="400px" height="250px" alt={key} key={key} />
          <br />
        </React.Fragment>;
        if (!this.state.angolNyelv || !object.angol)
          objects.push(img);
        else
          objectsAngol.push(img);
      });
    }
    return (
      <div>
        <h6>Promóció:</h6>
        <b>Előadás: </b>
        {viewObj && viewObj.cim}
        <br />
        <b>Helyszín(ek): </b>
        {viewObj && viewObj.helyszin}
        <br />
        <b>Képek: </b>
        {(viewObj && objects.length !== 0) && objects}
        {this.state.angolNyelv &&
          <div>
            <b>Képek (angol): </b>
            {(viewObj && objects.length !== 0) && objectsAngol}
          </div>
        }
      </div>
    );
  }

  renderTable = () => {

    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: "cim",
        text: "Film címe",
        filter: textFilter({
          delay: 400,
          placeholder: "Keresés..."
        }),
        sort: true
      },
      {
        dataField: "helyszin",
        text: "Helyszín(ek)",
        filter: textFilter({
          delay: 400,
          placeholder: "Keresés..."
        }),
        sort: true
      },
      {
        dataField: "id",
        text: "Műveletek",
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.baseJson}
        columns={columns}
        filter={filterFactory()}
        paginationFactory={paginationFactory(options)}
      />
    );
  };

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listPromocio()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deletePromocio()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getPromocioView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" >
          <RFForm
            modal
            onSubmit={this.savePromocio}
            title={this.state.formTypeStatus == 'FEL' ? 'Promóció rögzítése': 'Promóció módosítása'}
            footer={
              <>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getPromocioForm(this.state.currentId)}
                />),
              DATA: 
                <PromociokForm 
                  angolNyelv={this.state.angolNyelv}
                  modositas={!!this.state.currentId}
                  formEloadas={this.state.formEloadas}
                  formHelyszinek={this.state.formHelyszinek}
                  formObjects={this.state.formObjects}
                  formObjectsAngol={this.state.formObjectsAngol}
                  onDropObjects={this.onDropObjects}
                  onDeleteClick={this.onDeleteClick}
                  handleSelectInputChange={this.handleSelectInputChange}
                  handleImgClick={this.handleImgClick}
                />
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.kepModal} toggle={this.toggleKepModal} backdrop="static">
          <Card style={{ marginBottom: "0", border: "none" }}>
            <RFForm onSubmit={() => {}}>
              {this.state.img &&
                <React.Fragment>
                  <CardImg
                    src={this.state.img.src ? this.state.img.src : "data:image/bmp;base64," + this.state.img.content}
                    onClick={this.handleAltChangeClick} />
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <RFField
                      placeholder="Alt tag..."
                      onChange={(e, v) => { this.setState(prevState => ({ img: { ...prevState.img, alt: v } })) }}
                      value={this.state.img.alt}
                      disabled={this.state.img.id}
                      name="imgAltTag"
                    />
                    <Button className="btn-cursor-pointer pull-right" color="secondary" onClick={this.handleAltChangeClick}>
                      OK
                    </Button>
                  </div>
                </React.Fragment>
              }
            </RFForm>
          </Card>
        </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új promóció'}
            </Button>
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

export default PromociokContent;
